import { createAsyncThunk } from "@reduxjs/toolkit";
import { AppId, AppThunkAPIType } from "../../../app/appTypes";
import { postWithAuth } from "../../../http";
import { dispatchURSChanged, Urs } from "../UrsSlice";

export const prepareUrsTemplateAIAgent = createAsyncThunk<boolean, { documentId: AppId; blobId: string }
    , AppThunkAPIType>("document-urs-template/prepareUrsTemplateAIAgent",
        async ({ documentId, blobId }, { dispatch, rejectWithValue }) => {
            const result = await dispatch(postWithAuth({
                url: `api/UrsTemplate/${documentId}/ai/prepare/${blobId}`,
                payload: {}
            }))
            const { payload } = result
            if (postWithAuth.fulfilled.match(result)) {
                return payload as boolean
            } else {
                return rejectWithValue(payload ?? { kind: 'unknown' })
            }
        })


export type GenerateUrsTemplatePayload = {
    documentId: string;
    fileId: string;
    typeCode: string;
    language: string;
};

export const generateUrsTemplateAIAgent = createAsyncThunk<
    Urs,
    GenerateUrsTemplatePayload,
    AppThunkAPIType
>(
    "document-urs-template/generateUrsTemplateAIAgent",
    async (
        { documentId, fileId, typeCode, language },
        { dispatch, rejectWithValue }
    ) => {
        const result = await dispatch(
            postWithAuth({
                url: `api/UrsTemplate/${documentId}/ai/generate`,
                payload: {
                    fileId,
                    typeCode,
                    language,
                },
            })
        );

        const { payload } = result;

        if (postWithAuth.fulfilled.match(result)) {
            dispatchURSChanged(payload)

            return payload as Urs;
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" });
        }
    }
);